import { Spinner } from '@frontend/elements';
import { CommonMessage } from '@frontend/lang';
import { Role } from '@frontend/role/types';
import { FormattedMessage } from 'react-intl';

import useProfileRolesList from './profile-roles-list.controller';

export interface ProfileRolesListProps {
    userId?: string;
}

const ID = 'profile-roles-list';

const ProfileRolesList = (props: ProfileRolesListProps) => {
    const { roles, isLoading } = useProfileRolesList(props);

    return (
        <div className='bg-background-surface outline-border-default text-foreground-default flex w-full flex-col items-start justify-between self-stretch rounded-2xl pb-4 font-medium outline outline-offset-[-1px]'>
            <h3 className='p-4 text-xl font-semibold'>{CommonMessage.OBJECTS.ROLE.PLURAL}</h3>

            {isLoading ? (
                <div className='py-2'>
                    <Spinner />
                </div>
            ) : roles?.length ? (
                <div className='flex w-full flex-col'>
                    <div
                        className='border-border-default grid w-full gap-4 border-b px-4 py-3'
                        style={{ gridTemplateColumns: '200px 1fr' }}>
                        <div>Name</div>
                        <div>Type</div>
                    </div>

                    <div className='w-full'>
                        {roles.map((role: Role) => (
                            <div
                                key={(role as any).id ?? role.name}
                                className='border-border-default grid items-center gap-4 border-b px-4 py-3 text-sm last:border-b-0'
                                style={{ gridTemplateColumns: '200px 1fr' }}>
                                <div>{role.name}</div>
                                <div className='text-brand-muted'>{(role as any).type ?? (role as any).roleType ?? '-'}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className='text-brand-muted p-4'>
                    {' '}
                    <FormattedMessage
                        id='role-card.no-roles-assigned'
                        defaultMessage='No roles assigned'
                    />
                </div>
            )}
        </div>
    );
};

export default ProfileRolesList;
